import React, { useEffect, useState } from 'react';
import "./priceList.css";
import api from '../../axiosInstance';
import { useParams } from 'react-router-dom';
import { TextField } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
// import { Button, TextField,  } from "@mui/material";
// import {  Box } from "@mui/material";

import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import priceListdata from './priceListdata.json'
import CreateProductPriceList from './CreateProductPriceList';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/Delete';
const theme = createTheme({
  typography: {
    fontFamily: "Calibri, sans-serif",
  },
});




function ViewPricelistHistory() {
  const { dpid, cid } = useParams(); // Extract ID from URL


  // const rowdata = priceListdata?.myprice?.map((item) => item)


  const [createProductDetails, setcreateProductDetails] = useState([])
  const [getPriceListResponseData, setgetPriceListResponseData] = useState([])

  const [DeleteData, setDeleteData] = useState([])

  const fetchPricelist = async () => {
    try {
      const response = await api.get(`/productpricelist?DPID=${dpid}`);
      console.log("Response", response)
      if (response.status === 200) {
        setgetPriceListResponseData(response?.data?.data)
        console.log("Pricelist", response.data.data);
      }
    } catch (error) {
      console.error('Error fetching Pricelist', error);
    }
  };




  const deleteProductPriceList = async (id) => {
    if (!id) {
      console.error("Error: ID is required for deletion.");
      return;
    }

    const apiUrl = `productpricelist/${id}`;

    // Show confirmation dialog before deleting
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.delete(apiUrl);

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: response.data?.message || "Product price list deleted successfully.",
        });

        setDeleteData(response.data);
      } catch (error) {
        console.error("Delete Error:", error.response ? error.response.data : error.message);

        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.message || "Something went wrong.",
        });
      }
    }
  };



  useEffect(() => {
    fetchPricelist()
  }, [DeleteData, createProductDetails])


  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "price", headerName: "price", width: 150 },
    { field: "effected_from", headerName: "Date", width: 200 },
    { field: "created_at", headerName: "Create Date", width: 200 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 250,
      renderCell: (params) => (
        <>
          <div className='d-flex  align-items-center h-100 gap-4'>
            <IconButton >
              <CreateProductPriceList dpid={dpid} setcreateProductDetails={setcreateProductDetails} editData={params?.row}/>
            </IconButton>
            <IconButton onClick={() => deleteProductPriceList(params?.row?.id)}>
              <DeleteIcon />
            </IconButton>

          </div>
        </>
      ),
    },
    // {
    //   field: "selling_price",
    //   headerName: "Selling Price",
    //   width: 180,
    //   renderCell: (params) => (
    //     <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>

    //       <TextField
    //         value={params.row.selling_price}
    //         // onChange={(e) =>
    //         //   handleChange(params.row.id, "selling_price", e.target.value)
    //         // }
    //         type="number"
    //         variant="outlined"
    //         size="small"
    //         sx={{
    //           // "& .MuiInputBase-input": {
    //           //   fontSize: "12px", // Smaller font
    //           //   height: "55px", // Reduce height
    //           // },
    //           "& .MuiOutlinedInput-root": {
    //             height: "30px", // Overall height of TextField
    //             marginTop: "10px",
    //             width: "90%",
    //           },
    //           "@media (max-width: 600px)": {
    //             "& .MuiOutlinedInput-root": {
    //               height: "30px", // Smaller height on small screens
    //               width: "80%",
    //             },
    //           },
    //         }}
    //       />
    //     </Box>
    //   ),

    // },

  ];



  console.log("did", priceListdata)

  return (
    <div className='row' style={{ height: "100%" }}>
      <div className='col-sm-12 col-md-9'>
        <div style={{ height: "100%" }}>
          <div className=" d-flex flex-warp justify-content-between align-items-center p-2">
            <h3 className='distributerfont'>Price List</h3>
            <div>
              <div className='d-flex align-items-center' >
                <TextField
                  id="standard-basic"
                  placeholder="Search"
                  variant="standard"
                  className='me-2'
                  sx={{
                    width: "8rem", // Set width
                    // "& input": {
                    //   fontSize: "14px", // Text inside the input field
                    // },
                    "& .MuiInputBase-input::placeholder": {
                      fontSize: "12px", // Reduce placeholder size

                    },
                  }}

                />
                <div className='search_icon'>
                  <SearchIcon fontSize='7px' />

                </div>
                <PersonIcon className='ms-2' />
                <div>

                </div>
              </div>
            </div>


          </div>
          <div className='d-flex justify-content-end align-items-center'>
            <CreateProductPriceList dpid={dpid} setcreateProductDetails={setcreateProductDetails} />
          </div>



          <div>
            <ThemeProvider theme={theme}>
              <div style={{ height: 400, width: "100%" }}>

                <DataGrid
                  rowSpacingType='border'

                  rows={getPriceListResponseData}
                  columns={columns}
                  // rowsPerPageOptions={[5]}
                  checkboxSelection  // Enable checkbox selection
                  disableRowSelectionOnClick
                  // onRowSelectionModelChange={(newRowSelectionModel) => {
                  //   setRowSelectionModel(newRowSelectionModel);
                  // }}
                  // rowSelectionModel={rowSelectionModel}
                  pagination={false}
                  hideFooter
                  sx={{
                    border: 'none', // Change outer border color
                    fontFamily: "Calibri, sans-serif",
                    "& .MuiCheckbox-root": {
                      padding: "4px",  // Reduce padding
                      transform: "scale(0.7)",  // Scale down checkbox size
                    },
                    "& .MuiDataGrid-row": {
                      border: "1px solid #dee2e6 !important",  // Remove row border
                      marginTop: "0.2rem",

                    },
                    "& .MuiDataGrid-cell": {
                      border: "none !important",  // Remove cell borders
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      border: "none !important", // Remove header row bottom border

                    },
                    "& .MuiDataGrid-filler": {
                      rowBorderColor: "none"
                    },
                    "& .MuiDataGrid-root": {
                      border: "none !important", // Removes outer border
                    },

                  }}

                />
              </div>
              {/* <div className='d-flex justify-content-end'>
                    <button className='submitbutton mt-2' onClick={handleSubmit}>
                      Submit
                    </button>
                  </div> */}
            </ThemeProvider>
          </div>

        </div>
      </div>
      <div className='col-sm-12 col-md-3 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
        <div className="bg-white my-4 mx-2 p-3 rounded-5">
          <h5>Details</h5>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.
          </p>
        </div>

      </div>


    </div>
  )
}

export default ViewPricelistHistory